import { render } from "./Income.vue?vue&type=template&id=52e63f84&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import "./Income.vue?vue&type=style&index=0&id=52e63f84&scoped=true&lang=less"

import exportComponent from "E:\\rt\\AndroidSdk\\qiugxiu\\web-tuiguangzu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e63f84"]])

export default __exports__